'use client'

import { ThemeProvider } from 'next-themes'
import { SidebarProvider } from '@/contexts/sidebar-context'
import { AuthProvider } from '@/providers/auth-provider'

export function Providers({ children }: Readonly<{ children: React.ReactNode }>) {
	return (
		<ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} disableTransitionOnChange={false}>
			<AuthProvider>
				<SidebarProvider>{children}</SidebarProvider>
			</AuthProvider>
		</ThemeProvider>
	)
}
